<template>
    <svg class="live-feed-table" viewBox="0 0 540 85" style="width: 100%; height: 100%;">
        <g v-for="(feedData, index) in feed">
            <text class="text" x="20%" :y="getY(index)" :fill-opacity="getOpacity(index)">{{feedData.hash}}</text>
            <text class="text" x="53%" :y="getY(index)" :fill-opacity="getOpacity(index)">{{feedData.date}}</text>
            <text class="text" x="72%" :y="getY(index)" :fill-opacity="getOpacity(index)">{{feedData.ip}}</text>
            <text class="text" x="87%" :y="getY(index)" :fill-opacity="getOpacity(index)">{{feedData.country}}</text>
            <!--<text class="text" x="20%" :y="getY(index)" :fill-opacity="getOpacity(index)">{{feedData.hash}}</text>-->
            <!--<text class="text" x="47%" :y="getY(index)" :fill-opacity="getOpacity(index)">{{feedData.malwareType}}</text>-->
            <!--<text class="text" x="63%" :y="getY(index)" :fill-opacity="getOpacity(index)">{{feedData.date}}</text>-->
            <!--<text class="text" x="80%" :y="getY(index)" :fill-opacity="getOpacity(index)">{{feedData.ip}}</text>-->
            <!--<text class="text" x="93%" :y="getY(index)" :fill-opacity="getOpacity(index)">{{feedData.country}}</text>-->
        </g>
    </svg>
</template>

<script>
    export default {
        name: "live-feed-table",
        props: {
            feed: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
            }
        },
        methods: {
            getOpacity(index) {
                return (100 - (index * 20)) / 100;
            },
            getY(index) {
                return 10 + (index * 20);
            }
        }
    }
</script>

<style scoped>

    .live-feed-table {
        width: 100%;
        height: 100%;
    }

    .feed {
        width: 100%;
        height: 20%;
        text-align: left;
    }

    .feed-col {
        display: inline-block;
        height: 100%;
    }

    .text {
        font-family: 'Digital-Serial-Bold';
        font-size: 8.2px;
        font-weight: bold;
        color: rgba(255, 0, 67, 1);
        fill: rgba(255, 0, 67, 1);
        text-anchor: middle;
    }


</style>



// WEBPACK FOOTER //
// src/components/live-feed-table/LiveFeedTable.vue